// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubscriptionTerms_TermIdInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * SubscriptionTerms_TermIdInput — body for the two endpoints that act on one
 * existing document: POST /subscriptions/admin-terms/activate and
 * .../delete.
 *
 * One contract for both because the body is genuinely the same shape; the
 * endpoints differ in what they refuse, not in what they read.
 */
import { registerContract } from './validate'

export interface SubscriptionTerms_TermIdInput {
id: number
}

registerContract('SubscriptionTerms_TermIdInput', {
  id: { type: 'number',  required: true },
})
